/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { Icon, IconSize } from '@mpb-com/feather/components/atoms/icon';
import React from 'react';
import styled from 'styled-components';

import Keyline from '@toucan/images/keyline.svg';

import { getIconVariant } from './helpers';
import { styles } from './product-trust-card.styles';
import { ProductTrustCardProps, StyledProductTrustCardProps } from './types';

export const StyledProductTrustCard = styled(
    'section'
)<StyledProductTrustCardProps>`
    ${styles}
`;

export const DEFAULT_TEST_ID = 'product-trust-card';

export const ProductTrustCard = ({
    heading,
    icon,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    variant,
    withKeyline = false,
    className = '',
    children,
    ...otherProps
}: ProductTrustCardProps) => {
    return (
        <StyledProductTrustCard
            data-testid={dataTestId}
            variant={variant}
            {...otherProps}
        >
            <div
                className={`product-trust-card-container ${className}`}
                data-testid={`${dataTestId}-container`}
            >
                {withKeyline && <Keyline className="keyline" />}
                <Icon
                    size={IconSize.S}
                    variant={getIconVariant(variant)}
                    data-testid={`${dataTestId}__icon`}
                    className={'product-trust-card-icon'}
                >
                    {icon}
                </Icon>

                <Heading
                    size={HeadingSize.H5}
                    className="title"
                    data-testid={`${dataTestId}__heading`}
                >
                    {heading}
                </Heading>
                <div
                    data-testid={`${dataTestId}__children`}
                    className="product-trust-card-children"
                >
                    {children}
                </div>
            </div>
        </StyledProductTrustCard>
    );
};
